import styled from "styled-components";
import { BorderColors } from "@abel-technologies-as/components";

const ModalBody = styled.div``;

const Divider = styled.div`
	border-bottom: 1px solid ${BorderColors.Secondary};
`;

export { ModalBody, Divider };
